import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const { checkAuth } = useAuth();
  const [state, setState] = useState({ status: "loading", message: "" });
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    api.post("/auth/verify-email", { token: params.get("token") || "" })
      .then(() => { setState({ status: "ok" }); checkAuth(); })
      .catch((e) => setState({ status: "error", message: formatApiError(e) }));
  }, [params, checkAuth]);

  return (
    <div className="container-x flex min-h-[60vh] items-center justify-center py-16" data-testid="verify-email-page">
      <div className="panel w-full max-w-md p-8 text-center sm:p-10">
        {state.status === "loading" && <Loader2 className="mx-auto h-8 w-8 animate-spin text-emerald-500" />}
        {state.status === "ok" && (
          <>
            <CheckCircle2 className="mx-auto h-10 w-10 text-emerald-400" />
            <h1 className="mt-6 font-display text-2xl font-semibold text-white" data-testid="verify-email-success">Email verified</h1>
            <p className="mt-3 text-sm text-slate-400">Next, complete identity verification to start investing.</p>
            <Link to="/verification" className="btn-primary mt-8 w-full" data-testid="verify-email-continue-button">Continue to verification</Link>
          </>
        )}
        {state.status === "error" && (
          <>
            <XCircle className="mx-auto h-10 w-10 text-red-400" />
            <h1 className="mt-6 font-display text-2xl font-semibold text-white">Link not valid</h1>
            <p className="mt-3 text-sm text-slate-400" data-testid="verify-email-error">{state.message}. You can request a new link from your dashboard.</p>
            <Link to="/dashboard" className="btn-ghost mt-8 w-full" data-testid="verify-email-dashboard-link">Go to dashboard</Link>
          </>
        )}
      </div>
    </div>
  );
}
